import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UserState {
  email: string | null;
  accessToken: string | null;
}

const initialState: UserState = {
  email: null,
  accessToken: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (
      state,
      action: PayloadAction<{ email: string; accessToken: string }>
    ) => {
      state.email = action.payload.email;
      state.accessToken = action.payload.accessToken;
    },
    clearUser: (state) => {
      state.email = null;
      state.accessToken = null;
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;

export default userSlice.reducer;
